export const getLogo = () =>
  isMobio360Plus()
    ? "./img/logo-mobio360plus.png"
    : isAfricatv()
      ? "./img/africatv_logo.svg"
      : isVibe360()
        ? "./img/vibe360_logo.svg"
        : isCine360()
          ? "./img/cine360_logo.svg"
          : isMobioplus()
            ? "/img/mobioplus_logo.svg"
            : isMundo360()
              ? "./img/mundo360.svg"
              : isMobizone360()
                ? "./img/mobizone360-logo.svg"
                : isMobioSphere360()
                  ? "./img/mobiosphere360-logo.svg"
                  : "./img/logo.png";

export const getText = () =>
  isMobio360Plus()
    ? "Mobio360+"
    : isAfricatv()
      ? "Africatv"
      : isVibe360()
        ? "vibe360"
        : isCine360()
          ? "cine360"
          : isMobioplus()
            ? "Mobioplus"
            : isMundo360()
              ? "Mundo360"
              : isMobizone360()
                ? "Mobizone360"
                : isMobioSphere360()
                  ? "MobioSphere360"
                  : "Mobio360";

export const isMobio360Plus = () => {
  return window.location.hostname.includes("mobio360plus");
  // || window.location.hostname.includes('localhost')
};

export const isAfricatv = () => {
  return window.location.hostname.includes("africatv");
  // || window.location.hostname.includes('localhost')
};
export const isMobioplus = () => {
  return window.location.hostname.includes("plus");
  //|| window.location.hostname.includes("localhost")
};

export const isVibe360 = () => {
  return window.location.hostname.includes("vibe360");
  // || window.location.hostname.includes('localhost')
};
export const isMundo360 = () => {
  return window.location.hostname.includes("mundo-360");
  // || window.location.hostname.includes("localhost")
};

export const isCine360 = () => {
  return window.location.hostname.includes("cine360");
  //|| window.location.hostname.includes("localhost")
};
export const isMobizone360 = () => {
  return window.location.hostname.includes("mobizone360"); //||window.location.hostname.includes("localhost")
};
export const isMobioSphere360 = () => {
  return window.location.hostname.includes("mobiosphere360");
};

export const isMobio360 = () => {
  return (
    window.location.hostname.includes("mobio360") ||
    window.location.hostname.includes("localhost")
  );
};



// WEBPACK FOOTER //
// ./src/constants/multiDomains.js